import request from '@/api/request'

export default {
  getNewTemplate (payload) {
    const url = `/template/new`
    return request({ method: 'GET', url, headers: { 'Cache-Control': 'no-cache' } })
  },
  addNewTemplate (payload) {
    const url = `/template/add`
    const data = payload
    return request({ method: 'POST', url, data })
  }
}
